define.alias("ember-power-select/components/power-select/trigger", "calendar/components/power-select/trigger");